.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--s2);
  min-height: 52px;
  padding: 0 var(--s3);
  border: 1px solid transparent;
  border-radius: var(--r-pad);
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 650;
  font-stretch: 100%;
  min-width: 0;
  text-align: center;
  overflow-wrap: break-word;
  -webkit-user-select: none;
  user-select: none;
}

.full {
  width: 100%;
}

.large {
  min-height: 56px;
}

/* Maximum one per screen (fail list 10) */
.primary {
  composes: pressable from './surface.module.css';

  background: var(--ink);
  color: var(--panel);
  font-size: 1.1875rem;
  font-weight: 800;
  font-stretch: 105%;
}

/* Dig only: --led fill, --onLed label, full width, 56 px (DESIGN_SYSTEM §3) */
.dig {
  composes: pressable from './surface.module.css';

  width: 100%;
  min-height: 56px;
  background: var(--led);
  color: var(--onLed);
  font-size: 1.625rem;
  line-height: 1.15;
  font-weight: 850;
  font-stretch: 118%;
}

.secondary {
  composes: pad pressable from './surface.module.css';
}

.tertiary {
  min-height: var(--target);
  padding: 0 var(--s1);
  background: transparent;
  color: var(--slate);
}

.tertiary:active:not(:disabled, [aria-disabled='true']) {
  background: var(--panel2);
}

/* Toggles (e.g. Loop): selected = 2 px --slate outline and --slate label */
.secondary[aria-pressed='true'] {
  outline: 2px solid var(--slate);
  outline-offset: -2px;
  color: var(--slate);
}

.secondary[aria-pressed='true']:focus-visible {
  outline: var(--focus-ring);
  outline-offset: 2px;
}

.button:disabled,
.button[aria-disabled='true'] {
  opacity: 0.45;
  cursor: default;
}

/* Icon-only: 44 x 44 hit area (DESIGN_SYSTEM §2.4) */
.icon {
  padding: 0;
  min-width: var(--target);
  min-height: var(--target);
}

.stack {
  flex-direction: column;
  gap: 0;
  line-height: 1.2;
}

.button svg {
  flex: none;
}
